import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import Service from '../Classes/ClvrService'
import { ServiceDto } from '../Types/ServiceDto'

export class ServiceApiAdapter implements ApiDataAdapter<Service> {
    public createClass(apiData: ServiceDto): Service {
        return new Service({
            id: get(apiData, 'id'),
            groupId: get(apiData, 'group_id'),
            name: get(apiData, 'nom'),
        })
    }
}
